import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "./Loader/Loader";
import CityFilter from "./city/CityFilter";
import CategoryFilter from "./category/CategoryFilter";

const HomePage = lazy(() => import("./page/HomePage"));
const AboutPage = lazy(() => import("./page/AboutPage"));
const Register = lazy(() => import("./Form/Register"));
const Login = lazy(() => import("./Form/Login"));
const ProductListing = lazy(() => import("./ProductListing/ProductListing"));
const DashRoute = lazy(() => import("./Dashboard/DashRoute"));
const Sitemap = lazy(() => import("./component/SiteMap"));
const FreeListing = lazy(() => import("./component/FreeListing"));
const Advertise = lazy(() => import("./component/Advertise"));
const Contact = lazy(() => import("./component/Contact"));
const Policy = lazy(() => import("./component/Policy"));
const ErrorPage = lazy(() => import("./Errorpage/ErrorPage"));
const MarketingSolutions = lazy(() => import("./component/MarketingSolution"));
const CategoryData = lazy(() => import("./category/CategoryData"));
const Blog = lazy(() => import("./blog/Blog"));
const BlogLanding = lazy(() => import("./blog/BlogLanding"));
const Article = lazy(() => import("./component/Article"));
const Question = lazy(() => import("./component/Question"));
const LatestListing = lazy(() => import("./component/LatestListing"));
const StateCity = lazy(() => import("./city/StateCity"));
const ProductLanding = lazy(() => import("./ProductListing/ProductLanding"));
const FAQ = lazy(() => import("./component/Faq"));
const QuestionHome = lazy(() => import("./Question/QuestionHome"));
const Subject = lazy(() => import("./Question/Subject"));
const MainLayout = lazy(() => import("./Question/MainLayout"));
const CategoryPage = lazy(() => import("./Question/SubjectPage"));
const CategoryLanding = lazy(() => import("./Question/CategoryLanding"));
const FilterProduct = lazy(() => import("./ProductListing/FilterProduct"));
const QuestionLanding = lazy(() => import("./Question/QuestionLanding"));
const UnAnswered = lazy(() => import("./Question/UnAnswered"));
const LeaderBoard = lazy(() => import("./Question/LeaderBoard"));

const withSuspense = (element: React.ReactNode) => (
  <Suspense fallback={<Loader />}>{element}</Suspense>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: withSuspense(<HomePage />),
    errorElement: withSuspense(<ErrorPage />),
  },
  {
    path: "/about-us",
    element: withSuspense(<AboutPage />),
  },
  {
    path: "/vendor/signup",
    element: withSuspense(<Register />),
  },
  {
    path: "/vendor/login",
    element: withSuspense(<Login />),
  },
  {
    path: "/all-product",
    element: withSuspense(<ProductListing />),
  },
  {
    path: "/listings",
    element: withSuspense(<ProductListing />),
  },
  {
    path: "/listings/category/:userCategory",
    element: withSuspense(<FilterProduct />),
  },
  {
    path: "/listings/city/:userCity",
    element: withSuspense(<FilterProduct />),
  },
  {
    path: "/listings/search/:userCategory/:userCity",
    element: withSuspense(<FilterProduct />),
  },
  {
    path: "/listings/:userTitle/:userId",
    element: withSuspense(
      <>
        <ProductLanding />
        <Article />
        <Question />
      </>
    ),
  },
  {
    path: "/dashboard",
    element: withSuspense(<DashRoute />),
  },
  {
    path: "/dashboard/:subpage",
    element: withSuspense(<DashRoute />),
  },
  {
    path: "/sitemap",
    element: withSuspense(<Sitemap />),
  },
  {
    path: "/free-listing",
    element: withSuspense(<FreeListing />),
  },
  {
    path: "/advertise",
    element: withSuspense(<Advertise />),
  },
  {
    path: "/contact",
    element: withSuspense(<Contact />),
  },
  {
    path: "/privacy-policy",
    element: withSuspense(<Policy />),
  },
  {
    path: "/marketing-solutions",
    element: withSuspense(<MarketingSolutions />),
  },
  {
    path: "/category",
    element: withSuspense(
      <>
        <CategoryData />
        <LatestListing />
        <Article />
        <Question />
      </>
    ),
  },
  {
    path: "/blog",
    element: withSuspense(<Blog />),
  },
  {
    path: "/blog/:userTitle",
    element: withSuspense(<BlogLanding />),
  },
  {
    path: "/blog/category/:category",
    element: withSuspense(<Blog />),
  },
  {
    path: "/category",
    element: withSuspense(
      <>
        <CategoryData />
      </>
    ),
  },
  {
    path: "/category/:userCategory",
    element: withSuspense(
      <>
        <CategoryFilter />
      </>
    ),
  },
  {
    path: "/category/:userCategory/:userSubCategory",
    element: withSuspense(
      <>
        <CategoryFilter />
      </>
    ),
  },
  {
    path: "/usa",
    element: withSuspense(
      <>
        <StateCity />
        <LatestListing />
        <Article />
        <Question />
      </>
    ),
  },
  {
    path: "/usa/:userState",
    element: withSuspense(
      <>
        <CityFilter />
      </>
    ),
  },
  {
    path: "/usa/:userState/:userCity",
    element: withSuspense(
      <>
        <CityFilter />
      </>
    ),
  },
  {
    path: "/faq",
    element: withSuspense(<FAQ />),
  },
  {
    path: "/question",
    element: withSuspense(<QuestionHome />),
  },
  {
    path: "/question/subject",
    element: withSuspense(
      <MainLayout>
        <Subject />
      </MainLayout>
    ),
  },
  {
    path: "/question/subject/:subject",
    element: withSuspense(
      <MainLayout>
        <CategoryPage />
      </MainLayout>
    ),
  },
  {
    path: "/question/category/:category",
    element: withSuspense(
      <MainLayout>
        <CategoryLanding />
      </MainLayout>
    ),
  },
  {
    path: "/question/:category/:question",
    element: withSuspense(
      <MainLayout>
        <QuestionLanding />
      </MainLayout>
    ),
  },
  {
    path: "/question/unanswered",
    element: withSuspense(
      <MainLayout>
        <UnAnswered />
      </MainLayout>
    ),
  },
  {
    path: "/leaderboard",
    element: withSuspense(
      <MainLayout>
        <LeaderBoard />
      </MainLayout>
    ),
  },
]);

export default router;
